import {EmployeeDto} from '../../../../../../PRMGApiClient';
import {action, makeObservable, observable} from 'mobx';
import {Api} from '../../../../../../PRMGApiClient/ApiClient';
import {showCommunicationError} from '../../../helpers/alerts';
import {TablePaginationConfig} from 'antd';
import {FilterValue} from 'antd/es/table/interface';

export class EmployeesState {
  @observable
  items: Array<EmployeeDto> = [];

  @observable
  pageNumber: number = 1;

  @observable
  pageSize: number = 10;

  @observable
  total: number = 0;

  @observable
  isLoading: boolean = false;

  filterUserName: string | undefined;

  constructor() {
    makeObservable(this);
  }

  @action
  loadEmployees() {
    this.isLoading = true;
    Api.Employee.apiEmployeeFindByGet({
      pageNumber: this.pageNumber,
    })
      .then((res) => {
        this.setItems(res.content?.items);
        this.setTotal(res.content?.total);
      })
      .catch(showCommunicationError)
      .finally(() => {
        this.isLoading = false;
      });
  }

  @action
  setItems(items: Array<EmployeeDto> | null | undefined) {
    this.items = items || [];
  }

  @action
  setTotal(number: number | undefined) {
    this.total = number ?? 0;
  }

  @action
  filterEmployeeName() {
    console.log('filter employee name');
    return true;
  }

  @action
  setEmployeesFilters(employeeId?: number) {
    // if (vehicleId) {
    //   Api.Car.getCarById({id: vehicleId})
    //     .then((res) => {
    //       this.filterCarName =
    //         res.content?.carModelName + ' ' + res.content?.carMakeName + ' ' + res.content?.manufactureYear;
    //       this.filtersCarId = vehicleId;
    //       this.loadServices();
    //     })
    //     .catch(showCommunicationError);
    // } else {
    //   this.filterCarName = undefined;
    //   this.filtersCarId = undefined;
    //   this.loadServices();
    // }
    console.log(employeeId);
  }

  @action
  setPagination(pagination: TablePaginationConfig) {
    this.pageNumber = pagination.current || 1;
    this.pageSize = pagination.pageSize || 10;
    this.loadEmployees();
  }

  setFilters(filters: Record<string, FilterValue | null>) {
    console.log(filters);
    this.loadEmployees();
  }
}
